import Icons from '@/const/icons';
import {
	ActionRequiredType,
	DocumentModalType,
	FileType,
	ReviewSignStatus,
} from '@/interfaces';

const MODAL_DOCUMENT_TYPES: ActionRequiredType[] = ['FOLLOW_UP_DOCUMENT'];

export const getDocumentIcon = (nameFile: string): string => {
	return nameFile === 'Complaint' ||
		nameFile === 'Demand Letter' ||
		nameFile === 'Claim Form' ||
		nameFile === 'Opt' ||
		nameFile === 'Settlement Agreement'
		? Icons.pinFulledGreen
		: nameFile?.includes('Response to Question')
		? Icons.messageQuestionInterrogation
		: Icons.file;
};

export const shouldOpenDocumentModal = (record: FileType): boolean => {
	if (record?.type) return MODAL_DOCUMENT_TYPES.includes(record.type);
	return (
		record?.file_name === 'Claim Form' ||
		record?.file_name?.includes('Response to Question') ||
		record?.file_name === 'Opt'
	);
};

export const getDocumentModalType = (record: FileType): DocumentModalType => {
	const splitPath = record.file_path?.split('/').at(0);
	const isReviewSign = splitPath?.includes('signature');
	const isRetainer = record.file_name === 'Retainer';

	return {
		isReviewSign,
		isRetainer,
		isFollowUpDocument:
			record?.type && record.type.includes('FOLLOW_UP_DOCUMENT'),
	};
};

export const getReviewSignStatus = (
	reviewSign: FileType | undefined
): ReviewSignStatus => {
	let isSigned = '';
	let isApproved = '';
	let actionId = '';

	if (reviewSign?.file_name === 'Retainer') {
		isSigned = String(reviewSign.is_approved);
		isApproved = String(reviewSign.is_approved);
		actionId = String(reviewSign.action_id);
	} else {
		const splitPath = reviewSign?.file_path?.split('/');
		actionId = splitPath ? splitPath?.at(1)?.split('=').at(1) ?? '0' : '0';
		isSigned = splitPath
			? splitPath?.at(2)?.split('=').at(1) ?? 'false'
			: 'false';
		isApproved = splitPath
			? splitPath?.at(3)?.split('=').at(1) ?? 'false'
			: 'false';
	}

	return {
		actionId: Number(actionId),
		isSigned: isSigned === 'true',
		isApproved: isApproved === 'true',
	};
};

export const isReviewSignDocument = (record: FileType): boolean | undefined => {
	const splitPath = record?.file_path?.split('/');
	return (
		splitPath?.at(0)?.startsWith('signature') || record.file_name === 'Retainer'
	);
};

export const getDocumentDisplayName = (item: FileType): string => {
	if (item.file_name === 'Opt') return 'Signed Opt Out Request';
	if (!item.file_name) return item?.action?.name ?? 'Unknown';

	return item.file_name;
};
